// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","footerLinks":"Footer_footerLinks__3+3cY","footerLinksMobile":"Footer_footerLinksMobile__Fkra9"};